import {ChangeDetectorRef, Component, EventEmitter, Input, Output} from '@angular/core';
import {
  getAbn,
  getAcn,
  getAdverseOnFile,
  getApplicationNotes,
  getApplicationAssetCategory,
  getAssetCondition,
  getAssetDescription,
  getAssetFamily,
  getAssetMake,
  getAssetType,
  getAssetYear,
  getBrokerage,
  getBrokerApplicationId,
  getBrokerName,
  getBrokerSalesforceId,
  getAppSalesforceId,
  getCompanyName,
  getAbnAge,
  getAbnAgeWithContinuity,
  getGstAge,
  getGstAgeWithContinuity,
  getDeposit,
  getDocFeeFinanced,
  getEquifaxScoreAboveThresold,
  getFinanceType,
  getIndustrySector,
  getInterestRate,
  getInvoiceAmount,
  getLoanAmount,
  getAmountFinanced,
  getLoanPurpose,
  getLoanTerms,
  getOrganisationType,
  getPrimaryBusinessAddress,
  getTransactionType,
  getPropertyOwner,
  getRepaymentFrequency,
  getRevenue,
  getLVR,
  getAssetAvgRetail,
  getAssetGoodRetail,
  getAssetVehicle,
  getAppInfoBrokerEntityName,
  getBrokerContact,
  getIdTypes,
  Application,
  getRepaymentType,
  WithdrawApplicationFn,
  getOpportunityOwnerEmail,
  GetUserFn,
  AggregatorAndOriginatorListValueGetFn,
  UserSelectionValue,
  GetUserByAccessLevelFn,
  GetApplicationSettlementsOfficerFn,
  GetAmlOfficerCandidatesFn,
  amlOfficerSearchableSelectItems,
  amlOfficerSelectValue,
  canSetAmlOfficer,
  createUserSelectionEvent,
  emitUserSelectionEvent,
  mapBrokerUserToSearchableSelectItem,
  filterActiveUsers,
  findDefaultUser,
  setDefaultUserValues,
  mapBrokerCompanyToSearchableSelectItem,
  AccessLevelType,
  setDefaultSystemUserValues,
  mapUserToSearchableSelectItem,
  isAdmin,
  isAdminOrCreditUser,
  isAdminOrOperationUser,
  isAdminOrSalesUser
} from '@portal-workspace/grow-shared-library';
import {
  isInternalUser as utilIsInternalUser,
} from '@portal-workspace/grow-shared-library';
import {
  booleanToYesNo, displaybleDate,
  getApplicationStatus,
  getBrokerageAmount,
  getPaymentType,
  getBalloonPayment
} from '@portal-workspace/grow-shared-library';
import { ConsumerFinanceApplication } from '@portal-workspace/grow-shared-library';
import {GetUsersByOriginatorBusinessIdFunc, UserSelectionComponentEvent,
  applicationToApplicantDob,
  applicationToApplicantEmail,
  applicationToApplicantEmployer,
  applicationToApplicantEmploymentStatus,
  applicationToApplicantFirstName,
  applicationToApplicantGuarantor,
  applicationToApplicantLastName,
  applicationToApplicantMaritalStatus,
  applicationToApplicantMiddleName,
  applicationToApplicantMobile,
  applicationToApplicantNumberOfDependeants,
  applicationToApplicantPropertyOwnerWithAddress,
  applicationToApplicantRegularIncome,
  applicationToApplicantResidentialAddress,
  applicationToApplicantTimeInAddress,
  applicationToApplicantTitle,
  getUser,
  applicationToApplicantIdentification,
  ApplicationDialogService,
  PortalHotToastService,
  SearchableSelectItem
} from '@portal-workspace/grow-ui-library';
import { LooseCurrencyPipe } from '../../../pipes/loose-currency.pipe';
import { ReferencesDetailsComponent } from '../references-details.component';
import { IndividualDetailsComponent } from '../individual-details.component';
import { MatDividerModule } from '@angular/material/divider';
import { UserSelectionComponent } from '../../user-selection-component/user-selection.component';
import { CellComponent } from '../../application-summary-component/cell.component';
import { StatusBoxComponent } from '../../message-box/status-box.component';
import { NgTemplateOutlet, CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FlexModule } from '@angular/flex-layout/flex';
import { Subscription, combineLatest } from 'rxjs';
import {map} from 'rxjs/operators';

import { MatButtonModule } from '@angular/material/button';
import { ActivatedRoute } from '@angular/router';
import { SearchableSelectComponent } from '../../searchable-select-component/searchable-select.component';
import { FormControl } from '@angular/forms';
import { ApplicationService } from 'apps/portal2/src/app/service/application.service';


@Component({
    selector: 'consumer-app',
    templateUrl: './consumer-app.component.html',
    styleUrls: ['./consumer-app.component.scss'],
    standalone: true,
    imports: [MatCardModule, MatTooltipModule, MatButtonModule, MatTabsModule, FlexModule, NgTemplateOutlet, StatusBoxComponent, CellComponent, UserSelectionComponent, MatDividerModule, IndividualDetailsComponent, ReferencesDetailsComponent, LooseCurrencyPipe, SearchableSelectComponent, CommonModule]
})
export class ConsumerAppComponent {

  getCompanyName = getCompanyName;
  getAbnAge = getAbnAge;
  getAbnAgeWithContinuity = getAbnAgeWithContinuity;
  getGstAge = getGstAge;
  getGstAgeWithContinuity = getGstAgeWithContinuity;
  getBrokerApplicationId = getBrokerApplicationId;
  getBrokerSalesforceId = getBrokerSalesforceId;
  getAppSalesforceId = getAppSalesforceId;
  getBrokerName = getBrokerName;
  getAppInfoBrokerEntityName = getAppInfoBrokerEntityName;
  getOrganisationType = getOrganisationType;
  getInterestRate = getInterestRate;
  getLoanAmount = getLoanAmount;
  getAmountFinance = getAmountFinanced;
  getBrokerage = getBrokerage;
  getLVR = getLVR;
  getAbn = getAbn;
  getAcn = getAcn;
  getFinanceType = getFinanceType;
  getApplicationAssetCategory = getApplicationAssetCategory;
  getAssetType = getAssetType;
  getAssetMake = getAssetMake;
  getAssetFamily = getAssetFamily;
  getAssetYear = getAssetYear;
  getAssetDescription = getAssetDescription;
  getAssetVehicle = getAssetVehicle;
  getAssetCondition = getAssetCondition;
  getInvoiceAmount = getInvoiceAmount;
  getLoanTerms = getLoanTerms;
  getTransactionType = getTransactionType;
  getEquifaxScoreAboveThreshold = getEquifaxScoreAboveThresold;
  getAdverseOnFile = getAdverseOnFile;
  getPropertyOwner = getPropertyOwner;
  getDocFeeFinanced = getDocFeeFinanced;
  getRepaymentFrequency = getRepaymentFrequency;
  getDeposit = getDeposit;
  getRevenue = getRevenue;
  getIndustrySector = getIndustrySector;
  getApplicationNotes = getApplicationNotes;
  getPrimaryBusinessAddress = getPrimaryBusinessAddress;
  getAssetAvgRetail = getAssetAvgRetail;
  getAssetGoodRetail = getAssetGoodRetail;
  getLoanPurpose = getLoanPurpose;
  getBrokerContact = getBrokerContact;

  getApplicantTitle = applicationToApplicantTitle;
  getApplicantFirstName = applicationToApplicantFirstName;
  getApplicantLastName = applicationToApplicantLastName;
  getApplicantMiddleName = applicationToApplicantMiddleName;
  getApplicantIdentification = applicationToApplicantIdentification;
  getApplicantDob = applicationToApplicantDob;
  getApplicantResidentialAddress = applicationToApplicantResidentialAddress;
  getApplicantTimeInAddress = applicationToApplicantTimeInAddress;
  getApplicantPropertyOwnerWithAddress = applicationToApplicantPropertyOwnerWithAddress;
  getApplicantEmail = applicationToApplicantEmail;
  getApplicantMobile = applicationToApplicantMobile;
  getApplicantMaritalStatus = applicationToApplicantMaritalStatus;
  getApplicantNumberOfDependants = applicationToApplicantNumberOfDependeants;
  getApplicantEmploymentStatus = applicationToApplicantEmploymentStatus;
  getApplicantRegularIncome = applicationToApplicantRegularIncome;
  getApplicantEmployer = applicationToApplicantEmployer;
  getApplicantGuarantor = applicationToApplicantGuarantor;
  getBrokerageAmount = getBrokerageAmount;
  getPaymentType = getPaymentType;
  getBalloonPayment = getBalloonPayment;
  getRepaymentType = getRepaymentType;

  displayableDate = displaybleDate;
  booleanToYesNo = booleanToYesNo;

  getOpportunityOwnerEmail= getOpportunityOwnerEmail;

  idTypes = getIdTypes();
  idNumberLabel = 'ID Number'
  subscriptions: Subscription[] = [];
  applicationUserId!:number;
  AdditionalBrokerCorrespondentUserId?:number;
  creditOfficer = '';
  @Input({required: true}) application!: ConsumerFinanceApplication;
  @Input({required: true}) getUsersInCompanyFn!: GetUsersByOriginatorBusinessIdFunc;
  @Input({required: true}) withdrawApplicationFn!: WithdrawApplicationFn;
  @Input({required: true}) getUserFn!: GetUserFn;
  @Input({ required: true }) getUserByAccessLevelFn!: GetUserByAccessLevelFn;
  @Input({ required: true })getAggregatorsAndOriginatorsFn!: AggregatorAndOriginatorListValueGetFn;
  @Input({ required: true })getApplicationSettlementsOfficerFn!: GetApplicationSettlementsOfficerFn;
  @Input() getAmlOfficerCandidatesFn?: GetAmlOfficerCandidatesFn;
  @Output() events = new EventEmitter<UserSelectionComponentEvent & {type: 'submitter' | 'additional-correspondent' | 'broker' | 'sales-contact' | 'credit-officer' | 'settlement' | 'aml-officer'}>();
  @Output() navigateToApplications = new EventEmitter();

  applicationStatus: string | null = null;
  selectedBrokerName: string | undefined;
  user = getUser();

  constructor(
    private applicationDialogService: ApplicationDialogService,
    private toastService: PortalHotToastService,
    private activatedRoute: ActivatedRoute,
    private changeDetectorRef: ChangeDetectorRef,
    private applicationService: ApplicationService
  ) {
  }

  submitterUsers: SearchableSelectItem[] = [];
  salesContactUsers: SearchableSelectItem[] = [];
  settlementUsers: SearchableSelectItem[] = [];
  creditOfficerUsers: SearchableSelectItem[] = [];
  brokerCompanies: SearchableSelectItem[] = [];
  additionalCorrespondentUsers: SearchableSelectItem[] = [];
  defaultBrokerName: string | null = null;
  submitterControl = new FormControl<string[]>([]);
  brokerControl = new FormControl<string[]>([]);
  salesContactControl = new FormControl<string[]>([]);
  additionalCorrespondentControl = new FormControl<string[]>([]);
  settlementControl = new FormControl<string[]>([]);
  amlOfficerControl = new FormControl<string[]>([]);
  amlOfficerUsers: SearchableSelectItem[] = [];
  readonly canEditAmlOfficer = canSetAmlOfficer(getUser());
  creditOfficerControl = new FormControl<string[]>([]);
  selectedUser: UserSelectionValue | null = null;
  selectedSalesContact: UserSelectionValue | null = null;
  selectedBroker: UserSelectionValue | null = null;
  selectedAdditionalCorrespondent: UserSelectionValue | null = null;
  selectedSettlement: UserSelectionValue | null = null;
  selectedCreditOfficer: UserSelectionValue | null = null;
  defaultSubmitterName: string | null = null;
  defaultSalesContactName: string | null = null;
  defaultAdditionalCorrespondentName: string | null = null;
  defaultSettlementName: string | null = null;
  defaultCreditOfficerName: string | null = null;



  ngOnInit(): void {
    this.applicationStatus = getApplicationStatus(this.application);
    this.applicationUserId = (this.activatedRoute.snapshot.data as any).application.UserId;
    this.AdditionalBrokerCorrespondentUserId = (this.activatedRoute.snapshot.data as any)?.application?.AdditionalBrokerCorrespondent?.UserId;
    this.updateIdNumberLabel();

    this.loadBrokerCompanies();
    this.loadSubmitterUsers();
    this.loadAdditionalCorrespondentUsers();
    this.loadSalesContactUsers();
    this.loadSettlementUsers();
    this.loadAmlOfficerUsers();
    this.loadCreditOfficerUsers();
  
  }

  loadSettlementUsers(): void {
    if (this.application.settlmentUserId) {
      if (this.application.settlmentUserFirstName && 
          this.application.settlmentUserLastName) {
        
        const settlementOfficerItem: SearchableSelectItem = {
          id: this.application.settlmentUserId?.toString() ?? '',
          label: `${this.application.settlmentUserFirstName} ${this.application.settlmentUserLastName} ${this.application.settlmentUserEmail || ''}`.trim(),
          name: `${this.application.settlmentUserFirstName} ${this.application.settlmentUserLastName}`.trim(),
          email: this.application.settlmentUserEmail || null,
          value: this.application.settlmentUserId?.toString() ?? '',
          searchTerm: `${this.application.settlmentUserFirstName} ${this.application.settlmentUserLastName}`.toLowerCase()
        };
        
        this.settlementUsers = [settlementOfficerItem];
        
        const result = setDefaultUserValues(
          settlementOfficerItem,
          this.settlementControl,
          this.selectedSettlement,
          this.defaultSettlementName
        );
        this.selectedSettlement = result.selectedUser;
        this.defaultSettlementName = result.defaultUserName;
      }
    }
    
    const type: AccessLevelType = 'operations';
    this.subscriptions.push(
      combineLatest([
        this.getUserByAccessLevelFn(type),
        this.getApplicationSettlementsOfficerFn(),
      ]).pipe(
        map(([users, settlementOfficers]) => {
          const apiUsers = users
            ? users
                .filter((user) => filterActiveUsers(user, true))
                .map((user) => mapUserToSearchableSelectItem(user))
            : [];
          
          const currentSettlementId = this.application.settlmentUserId?.toString();
          
          if (apiUsers.length > 0) {
            const filteredApiUsers = currentSettlementId
              ? apiUsers.filter(user => user.value !== currentSettlementId)
              : apiUsers;
            
            this.settlementUsers = this.settlementUsers.length > 0
              ? [...this.settlementUsers, ...filteredApiUsers]
              : filteredApiUsers;
          }
          
        })
      ).subscribe()
    );
  }

  loadCreditOfficerUsers(): void {
    if (this.application.creditOfficerId) {
      if (this.application.creditOfficerFirstName && 
          this.application.creditOfficerLastName) {
        
        const creditOfficerItem: SearchableSelectItem = {
          id: this.application.creditOfficerId?.toString() ?? '',
          label: `${this.application.creditOfficerFirstName} ${this.application.creditOfficerLastName} ${this.application.creditOfficerEmail || ''}`.trim(),
          name: `${this.application.creditOfficerFirstName} ${this.application.creditOfficerLastName}`.trim(),
          email: this.application.creditOfficerEmail || null,
          value: this.application.creditOfficerId?.toString() ?? '',
          searchTerm: `${this.application.creditOfficerFirstName} ${this.application.creditOfficerLastName}`.toLowerCase()
        };
        
        this.creditOfficerUsers = [creditOfficerItem];
        
        const result = setDefaultUserValues(
          creditOfficerItem,
          this.creditOfficerControl,
          this.selectedCreditOfficer,
          this.defaultCreditOfficerName
        );
        this.selectedCreditOfficer = result.selectedUser;
        this.defaultCreditOfficerName = result.defaultUserName;
      } 

    } else {
      this.creditOfficer = 'System';
      this.defaultCreditOfficerName = 'System';
      
      const systemCreditItem: SearchableSelectItem = {
        id: 'system',
        label: 'System',
        name: 'System',
        email: null,
        value: 'system',
        searchTerm: 'system'
      };
      
      this.creditOfficerUsers = [systemCreditItem];
      this.creditOfficerControl.setValue(['system']);
    }
    
    const type: AccessLevelType = 'credit';
    this.subscriptions.push(
      this.getUserByAccessLevelFn(type).subscribe((users) => {
        const apiUsers = users
          ? users.map((user) => mapUserToSearchableSelectItem(user))
          : [];
        
        const currentOfficerId = this.application.creditOfficerId?.toString();
        
        if (apiUsers.length > 0) {
          const filteredApiUsers = currentOfficerId
            ? apiUsers.filter(user => user.value !== currentOfficerId)
            : apiUsers;
          
          this.creditOfficerUsers = this.creditOfficerUsers.length > 0
            ? [...this.creditOfficerUsers, ...filteredApiUsers]
            : filteredApiUsers;
        }
        
      })
    );
  }

  loadSalesContactUsers(): void {
    if (this.application.opportunityOwnerId && 
        this.application.opportunityOwnerFirstName && 
        this.application.opportunityOwnerLastName) {
      
      const opportunityOwnerItem: SearchableSelectItem = {
        id: this.application.opportunityOwnerId?.toString() ?? '',
        label: `${this.application.opportunityOwnerFirstName} ${this.application.opportunityOwnerLastName} ${this.application.opportunityOwnerEmail || ''}`.trim(),
        name: `${this.application.opportunityOwnerFirstName} ${this.application.opportunityOwnerLastName}`.trim(),
        email: this.application.opportunityOwnerEmail || null,
        value: this.application.opportunityOwnerId?.toString() ?? '',
        searchTerm: `${this.application.opportunityOwnerFirstName} ${this.application.opportunityOwnerLastName}`.toLowerCase()
      };
      
      this.salesContactUsers = [opportunityOwnerItem];
      
      const result = setDefaultUserValues(
        opportunityOwnerItem,
        this.salesContactControl,
        this.selectedSalesContact,
        this.defaultSalesContactName
      );
      this.selectedSalesContact = result.selectedUser;
      this.defaultSalesContactName = result.defaultUserName;
    } else {
      const result = setDefaultSystemUserValues(
        this.salesContactControl,
        this.selectedSalesContact,
        this.defaultSalesContactName,
        'sales'
      );
      this.selectedSalesContact = result.selectedUser;
    }
    
    const type: AccessLevelType = 'salesBDM,salesAM';
    this.subscriptions.push(
      this.getUserByAccessLevelFn(type).subscribe((users) => {
        const apiUsers = users
          ? users
              .filter((user) => filterActiveUsers(user, true))
              .map((user) => mapUserToSearchableSelectItem(user))
          : [];
        
        const currentOwnerId = this.application.opportunityOwnerId?.toString();
        
        if (apiUsers.length > 0) {
          const filteredApiUsers = currentOwnerId
            ? apiUsers.filter(user => user.value !== currentOwnerId)
            : apiUsers;
          
          this.salesContactUsers = this.salesContactUsers.length > 0
            ? [...this.salesContactUsers, ...filteredApiUsers]
            : filteredApiUsers;
        }
      })
    );
  }

  loadBrokerCompanies(): void {
    if (this.isInternalUser()) {
      this.getAggregatorsAndOriginatorsFn()
        .pipe(
          map((results: any) =>
            results.filter(
              (item: any) =>
                item.kind === 'Originator' || item.kind === 'Aggregator'
            )
          )
        )
        .subscribe((originators: any) => {
          this.brokerCompanies = originators.map(mapBrokerCompanyToSearchableSelectItem);
          
          const defaultBroker = findDefaultUser(
            this.brokerCompanies,
            this.application.AppInfo.BrokerSalesforceID
          );
          
          if (defaultBroker && 'value' in defaultBroker) {
            const result = setDefaultUserValues(
              defaultBroker,
              this.brokerControl,
              this.selectedBroker,
              this.defaultBrokerName
            );
            this.selectedBroker = result.selectedUser;
          }
        });
    } else {

      const brokerName = this.getAppInfoBrokerEntityName(this.application);
      const brokerItem: SearchableSelectItem = {
        id: this.application.AppInfo.BrokerSalesforceID ?? '',
        label: brokerName || '',
        name: brokerName || '',
        email: null,
        value: this.application.AppInfo.BrokerSalesforceID ?? '',
        searchTerm: (brokerName || '').toLowerCase()
      };
      
      this.brokerCompanies = [brokerItem];
      
      const result = setDefaultUserValues(
        brokerItem,
        this.brokerControl,
        this.selectedBroker,
        this.defaultBrokerName
      );
      this.selectedBroker = result.selectedUser;
      
    }
  }

  loadSubmitterUsers(): void {
    if (this.applicationUserId) {
      // id must be the Salesforce Contact Id (used downstream as sfContactId and pushed to
      // Opportunity.BrokerContact__c). Seeding it with the local UserId causes SF to reject the
      // update with "Introducer Contact: id value of incorrect type".
      const submitterItem: SearchableSelectItem = {
        id: this.application.BrokerContact?.Id ?? '',
        label: `${this.application.BrokerContact?.FirstName || ''} ${this.application.BrokerContact?.LastName || ''} ${this.application.BrokerContact?.Email || ''}`.trim(),
        name: `${this.application.BrokerContact?.FirstName || ''} ${this.application.BrokerContact?.LastName || ''}`.trim(),
        email: this.application.BrokerContact?.Email || null,
        value: this.applicationUserId.toString(),
        searchTerm: `${this.application.BrokerContact?.FirstName || ''} ${this.application.BrokerContact?.LastName || ''}`.toLowerCase()
      };
      
      this.submitterUsers = [submitterItem];
      
      const result = setDefaultUserValues(
        submitterItem,
        this.submitterControl,
        this.selectedUser,
        this.defaultSubmitterName
      );
      this.selectedUser = result.selectedUser;
    }
    
    this.subscriptions.push(
      this.getUsersInCompanyFn(
        this.application.OriginatorBusinessId
      ).subscribe((users) => {
        const apiUsers = users
          .filter((user) => filterActiveUsers(user, false))
          .map(mapBrokerUserToSearchableSelectItem);
        
        const currentSubmitterId = this.applicationUserId?.toString();
        
        if (apiUsers.length > 0) {
          const filteredApiUsers = currentSubmitterId
            ? apiUsers.filter(user => user.value !== currentSubmitterId)
            : apiUsers;
          
          this.submitterUsers = this.submitterUsers.length > 0
            ? [...this.submitterUsers, ...filteredApiUsers]
            : filteredApiUsers;
        }
      })    
    );
  }

  loadAdditionalCorrespondentUsers(): void {
    if (this.AdditionalBrokerCorrespondentUserId) {

      const correspondentItem: SearchableSelectItem = {
        id: this.AdditionalBrokerCorrespondentUserId.toString(),
        label: `${this.application.AdditionalBrokerCorrespondent?.Name || ''}`.trim(),
        name: `${this.application.AdditionalBrokerCorrespondent?.Name || ''}`.trim(),
        email: this.application.AdditionalBrokerCorrespondent?.Email || null,
        value: this.AdditionalBrokerCorrespondentUserId.toString(),
        searchTerm: `${this.application.AdditionalBrokerCorrespondent?.Name || ''}`.toLowerCase()
      };
      
      this.additionalCorrespondentUsers = [correspondentItem];
      
      const result = setDefaultUserValues(
        correspondentItem,
        this.additionalCorrespondentControl,
        this.selectedAdditionalCorrespondent,
        this.defaultAdditionalCorrespondentName
      );
      this.selectedAdditionalCorrespondent = result.selectedUser;
      this.defaultAdditionalCorrespondentName = result.defaultUserName;
    }
    
    this.subscriptions.push(
      this.getUsersInCompanyFn(
        this.application.OriginatorBusinessId
      ).subscribe((users) => {
        const apiUsers = users
          .filter((user) => filterActiveUsers(user, false))
          .map(mapBrokerUserToSearchableSelectItem);
        
        const currentCorrespondentId = this.AdditionalBrokerCorrespondentUserId?.toString();
        
        if (apiUsers.length > 0) {
          const filteredApiUsers = currentCorrespondentId
            ? apiUsers.filter(user => user.value !== currentCorrespondentId)
            : apiUsers;
          
            this.additionalCorrespondentUsers = this.additionalCorrespondentUsers.length > 0
            ? [...this.additionalCorrespondentUsers, ...filteredApiUsers]
            : filteredApiUsers;
        }
        
      })
    );
  }

  isInternalUser() {
    return utilIsInternalUser(getUser());
  }

  isAdminUser() {
    return isAdmin(getUser());
  }

  isAdminOrCredit() {
    return isAdminOrCreditUser(getUser()); 
  }

  isAdminOrOperationUser() {
    return isAdminOrOperationUser(getUser());
  }

  isAdminOrSalesUser() {
    return isAdminOrSalesUser(getUser());
  }

  isApplicationStage() {
    const stagesToCheck = ['QA', 'Settlement', 'Closed Lost', 'Closed Won'];
    
    const currentStageName = this.application.AppInfo.StageName?.trim();
    
    if (stagesToCheck.some(stage => stage === currentStageName)) {
      return false;
    }
    
    return true;
  }

  emitChangeSubmitterEvent(event: UserSelectionComponentEvent) {
    emitUserSelectionEvent(event, 'submitter', this.events);
  }

  emitChangeBrokerEvent(event: UserSelectionComponentEvent) {
    emitUserSelectionEvent(event, 'broker', this.events);
  }

  emitChangeSalesContactEvent(event: UserSelectionComponentEvent) {
    emitUserSelectionEvent(event, 'sales-contact', this.events);
  }

  emitChangeCreditOfficerEvent(event: UserSelectionComponentEvent) {
    emitUserSelectionEvent(event, 'credit-officer', this.events);
  }

  loadAmlOfficerUsers(): void {
    this.amlOfficerUsers = amlOfficerSearchableSelectItems(this.application, []);
    this.amlOfficerControl.setValue([amlOfficerSelectValue(this.application)]);
    if (!this.getAmlOfficerCandidatesFn) {
      return;
    }
    this.subscriptions.push(
      this.getAmlOfficerCandidatesFn().subscribe((candidates) => {
        this.amlOfficerUsers = amlOfficerSearchableSelectItems(this.application, candidates);
        this.changeDetectorRef.markForCheck();
      })
    );
  }

  onAmlOfficerChange(selectedItems: SearchableSelectItem[]) {
    if (selectedItems && selectedItems.length > 0) {
      emitUserSelectionEvent(createUserSelectionEvent(selectedItems[0]), 'aml-officer', this.events);
    }
  }

  emitChangeSettlementEvent(event: UserSelectionComponentEvent) {
    emitUserSelectionEvent(event, 'settlement', this.events);
  }

  emitChangeAdditionalCorrespondentEvent(event: UserSelectionComponentEvent) {
    emitUserSelectionEvent(event, 'additional-correspondent', this.events);
  }

  onSubmitterChange(selectedItems: SearchableSelectItem[]) {
    if (selectedItems && selectedItems.length > 0) {
      const selectedItem = selectedItems[0];

      const event = createUserSelectionEvent(selectedItem);
      this.selectedUser = event.value;
      this.applicationUserId = event.value?.UserId ?? 0;
      this.defaultSubmitterName = selectedItem.label;
      this.emitChangeSubmitterEvent(event);
    }
  }

  onSalesContactChange(selectedItems: SearchableSelectItem[]) {
    if (selectedItems && selectedItems.length > 0) {
      const selectedItem = selectedItems[0];

      const event = createUserSelectionEvent(selectedItem);
      this.selectedSalesContact = event.value;
      this.applicationUserId = event.value?.UserId ?? 0;
      this.defaultSalesContactName = selectedItem.label;
      this.emitChangeSalesContactEvent(event);
    }
  }

  onSettlementOfficerChange(selectedItems: SearchableSelectItem[]) {
    if (selectedItems && selectedItems.length > 0) {
      const selectedItem = selectedItems[0];

      const event = createUserSelectionEvent(selectedItem);
      if (event.value) {
        event.value.sfId = selectedItem.id; // Add sfId for settlement officer
      }
      this.selectedSettlement = event.value;
      this.applicationUserId = event.value?.UserId ?? 0;
      this.defaultSettlementName = selectedItem.label;
      this.emitChangeSettlementEvent(event);
    }
  }

  onCreditOfficerChange(selectedItems: SearchableSelectItem[]) {
    if (selectedItems && selectedItems.length > 0) {
      const selectedItem = selectedItems[0];

      const event = createUserSelectionEvent(selectedItem);
      this.selectedCreditOfficer = event.value;
      this.applicationUserId = event.value?.UserId ?? 0;
      this.defaultCreditOfficerName = selectedItem.label;
      this.emitChangeCreditOfficerEvent(event);
    }
  }

  onAdditionalCorrespondentChange(selectedItems: SearchableSelectItem[]) {
    if (selectedItems && selectedItems.length > 0) {
      const selectedItem = selectedItems[0];

      const event = createUserSelectionEvent(selectedItem);
      this.selectedAdditionalCorrespondent = event.value;
      this.applicationUserId = event.value?.UserId ?? 0;
      this.defaultAdditionalCorrespondentName = selectedItem.label;
      this.emitChangeAdditionalCorrespondentEvent(event);
    }
  }

  onBrokerChange(selectedItems: SearchableSelectItem[]) {
    if (selectedItems && selectedItems.length > 0) {
      const selectedItem = selectedItems[0];

      const event = createUserSelectionEvent(selectedItem);
      this.selectedBrokerName = event.value?.Name ?? '';
      this.defaultBrokerName = selectedItem.label;
      this.applicationUserId = event.value?.UserId ?? 0;
      this.emitChangeBrokerEvent(event);
    }
  }


  idTypeValueToLabel(application: Application) {
    const value = this.getApplicantIdentification(application)?.idType ?? ''
    return this.idTypes.find(type => type.value === value)?.label || '';
  }

  updateIdNumberLabel() {
    const value = this.getApplicantIdentification(this.application)?.idType ?? ''
    switch (value) {
      case 'drivers_licence':
        this.idNumberLabel = 'Licence Number';
        break;
      case 'passport':
        this.idNumberLabel = 'Passport Number';
        break;
      default:
        this.idNumberLabel = 'ID Number';
    }
  }

  onWithdrawApplication() {
    this.subscriptions.push(
      this.applicationDialogService.openConfirmationDialog({
        message: "Withdraw Application",
        subMessage: "Are you sure you want to withdraw this application?"
      }).afterClosed().subscribe(r => {
        if (r && r.readyForSubmission) {
          this.applicationDialogService.openWithdrawApplicationDialog({})
            .afterClosed().subscribe(result => {
              if (result && result.readyForSubmission) {
                this.withdrawApplicationFn({
                  salesforceId: this.application.AppInfoSalesforceID ?? '',
                  applicationId: this.application.ApplicationId,
                  reason: result.reason,
                  comment: result.comment,
                }).pipe(
                  this.toastService.spinnerObservable()
                ).subscribe(() => {
                  this.applicationDialogService.successDialog({
                    message: 'Success',
                    subMessage: `This application has been withdrawn successfully.`
                  }).afterClosed().subscribe(() => {
                    this.navigateToApplications.emit();
                  })
                })
              }
            })
        }
      })
    )
  }

  sendToDraft() {
    this.applicationDialogService.openConfirmationDialog({
      message: "Send To Draft",
      subMessage: "Are you sure you want to send this application to draft?<br><br>This will reset the application to the draft stage and clear all the changes you have made."
    }).afterClosed().subscribe(r => {
      if (r && r.readyForSubmission) {
        this.applicationService.setApplicationToDraftFn(this.application.ApplicationId)
          .pipe(
            this.toastService.spinnerObservable()
          ).subscribe(() => {
            document.location.reload();
          })
      }
    })
  }
}
